import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface AuthStore {
    selectedBranchId: string | null;
    setSelectedBranchId: (branchId: string | null) => void;
    clearSelectedBranchId: VoidFunction;

    isPairing: boolean;
    setIsPairing: (isPairing: boolean) => void;
}

export const useAuthStore = create(
    persist<AuthStore>(
        (set) => ({
            selectedBranchId: null,

            setSelectedBranchId: (branchId) => {
                return set({ selectedBranchId: branchId });
            },

            clearSelectedBranchId: () => set({ selectedBranchId: null }),

            isPairing: false,

            setIsPairing: (isPairing) => set({ isPairing }),
        }),
        {
            name: 'auth-store',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
